import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import "../../App.css";
import "../DoubleMatch/DoubleMatch.css";
import HeaderBack from "../../components/Header/HeaderBack";
import DiceLoading from "../../components/DiceLoading";
import GetOneProfile from "../../components/GetProfile/GetOneProfile.js";
import {
  getMyChoice,
  getOtherChoice,
} from "../../handlers/dictionaryHandler.js";

const HelperMatches = () => {
  const location = useLocation();
  const candidateId = location.state?.candidateId;
  const candidateName = location.state?.candidateName || "";
  const candidateGender = location.state?.candidateGender;
  const [prevMatch, setPrevMatch] = useState([]);

  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPrevMatches, setTotalPrevMatches] = useState(0);

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  useEffect(() => {
    if (!candidateId) {
      setIsDataLoaded(true);
      return;
    }

    loadMorePrevMatches(0, true);
  }, [candidateId]);

  const loadMorePrevMatches = async (offset = 0, isReset = false) => {
    try {
      const limit = 20;
      setIsLoading(true);

      const response = await axios.get(
        process.env.REACT_APP_LOCALHOST_ADDRESS +
          `/prevMatchesHelper/${offset}/${limit}/${candidateId}`,
        config,
      );

      if (!response.data || response.data.length === 0) {
        setTotalPrevMatches(0);
        if (isReset) {
          setPrevMatch([]);
        }
        return;
      }
      // console.log(response.data);
      setTotalPrevMatches(response.data[0].total || 0);
      // setCandidateName(response.data[0].candidateName || "");

      const userData = response.data.map((currentMatch) => {
        return {
          match: currentMatch,
          isOpen: false,
          isOtherProfileOpen: false,
        };
      });

      if (isReset) {
        setPrevMatch([...userData]);
      } else {
        setPrevMatch((prev) => [...prev, ...userData]);
      }
    } catch (error) {
      console.log(error);
      if (isReset) {
        setPrevMatch([]);
      }
    } finally {
      setIsLoading(false);
      setIsDataLoaded(true);
    }
  };

  return (
    <form className="double-match-form">
      <HeaderBack />
      <br />
      <div className="doublematch-body">
        {isDataLoaded ? (
          <>
            <div id="h1">התאמות שהתקבלו</div>

            <h5 style={{ textAlign: "center", marginBottom: "15px" }}>
              {candidateName !== ""
                ? "כאן אפשר לראות את ההתאמות של " + candidateName
                : "כאן אפשר לראות את ההתאמות של המועמד/ת"}
            </h5>

            <div className="messegeMatch" style={{ textAlign: "center" }}>
              {`אם נראית התאמה מעניינת, אפשר לעדכן את ${candidateName} להיכנס ולסמן תשובה.`}
            </div>

            <br />

            {!candidateId ? (
              <div className="pause-card">
                <div className="pause-title">לא נבחר מועמד</div>
              </div>
            ) : prevMatch.length > 0 ? (
              prevMatch.map((pMatch) => (
                <div
                  key={pMatch.match.prevMatchId}
                  className="match-card-container"
                  style={{ height: "auto" }}
                >
                  <div
                    className="linePlace"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="rowTitle"
                      style={{
                        minWidth: "unset",
                      }}
                    >
                      <div
                        className="rowTitle"
                        style={{
                          minWidth: "unset",
                        }}
                      >
                        {pMatch.match.isEmailSent == "1"
                          ? pMatch.match.prevMatch +
                            ` ❤️ שני הצדדים אמרו כן, כדאי להתעניין אם היה דייט`
                          : pMatch.match.prevMatch}
                      </div>
                    </div>
                  </div>

                  <div className="divider" />

                  <GetOneProfile
                    otherId={pMatch.match.otherId}
                    displayGender={candidateGender == 1 ? 2 : 1}
                    embedded={true}
                  />

                  <div
                    id={`helperMatchResponseArea${pMatch.match.prevMatchId}`}
                    className="lbl"
                  >
                    {pMatch.match.mySee != "1" && (
                      <div>{candidateName} עדיין לא ראה/תה את ההתאמה.</div>
                    )}

                    {pMatch.match.otherSee != "1" && (
                      <div>הצד השני עדיין לא ראה את ההתאמה.</div>
                    )}

                    <div>
                      <b>התגובה של {candidateName}: </b>
                      {getMyChoice(pMatch.match.myResponse)}
                    </div>

                    <div>
                      <b>תגובת הצד השני: </b>
                      {getOtherChoice(pMatch.match.otherResponse)}
                    </div>
                  </div>

                  <div
                    style={{
                      fontSize: "0.95rem",
                      color: "#666",
                      textAlign: "center",
                      marginTop: "10px",
                    }}
                  >
                    נראה מעניין? אפשר להפנות את {candidateName} להיכנס לדאבל
                    ולבדוק את ההתאמה.
                  </div>
                </div>
              ))
            ) : (
              <div className="pause-card">
                <div className="pause-title">אין כרגע התאמות להצגה</div>
              </div>
            )}

            {isLoading && <DiceLoading />}

            <Link to="/helperhome">
              <div
                className="back-link-minimal"
                style={{
                  display: "block",
                  width: "fit-content",
                  margin: "0 auto",
                }}
              >
                חזרה
              </div>
            </Link>
          </>
        ) : (
          <DiceLoading />
        )}
      </div>
    </form>
  );
};

export default HelperMatches;
